import styled from '@emotion/styled'
import {motion} from 'motion/react'

import {cssTheme} from '@vio/atlas/themes'
import {Tooltip} from '@vio/atlas/Tooltip'

// Measured rendered height of the BottomCTA's CompactOffer row (above safe-area).
// Used to offset the fixed toast above the sticky footer when it's visible.
export const FOOTER_HEIGHT = 68

// Measured rendered height of the CallToBook AP_STICKY bar (above safe-area).
// Added to FOOTER_HEIGHT when the CallToBook bar is also visible.
export const CALL_TO_BOOK_HEIGHT = 34

const ICON_BADGE_SIZE = 24

export const StickyContainer = styled(motion.div)`
  position: fixed;
  left: 0;
  right: 0;
  padding: ${cssTheme.layout.spacing.s250} ${cssTheme.layout.spacing.s300};
  padding-bottom: calc(
    ${cssTheme.layout.spacing.s600} + env(safe-area-inset-bottom)
  );
  z-index: 100;
  pointer-events: none;
  transition: bottom 0.5s ease;
`

export const ToastCard = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s300};
  background: ${cssTheme.colors.background.neutral.primary};
  border-radius: ${cssTheme.layout.radius.lg};
  border: 1px solid ${cssTheme.colors.border.neutral.secondary};
  box-shadow: ${cssTheme.shadows.floating};
  padding-block: ${cssTheme.layout.spacing.s250};
  padding-inline: ${cssTheme.layout.spacing.s300}
    ${cssTheme.layout.spacing.s200};
  pointer-events: auto;
`

export const TextGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s250};
  flex: 1;
  min-width: 0;
`

export const IconBadge = styled.div`
  flex-shrink: 0;
  width: ${ICON_BADGE_SIZE}px;
  height: ${ICON_BADGE_SIZE}px;
  border-radius: 50%;
  background: ${cssTheme.colors.background.brand.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${cssTheme.colors.content.brand.primary};
`

export const TextRow = styled.div`
  flex: 1;
  min-width: 0;
`

export const DismissButtonWrapper = styled.div`
  flex-shrink: 0;
`

export const PaddedTooltip = styled(Tooltip)`
  margin-left: ${cssTheme.layout.spacing.s400};
  margin-right: ${cssTheme.layout.spacing.s400};
`
